// extracted by mini-css-extract-plugin
module.exports = {"title":"_6eb00b8e53--title--3-SXH","small_indent":"_6eb00b8e53--small_indent--3OJGI","middle_indent":"_6eb00b8e53--middle_indent--3AGdS"};